import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from "react";
import { AssetModalMobileTabNavigation } from "./MobileTabNavigation/MobileTabNavigation";
import { Visualizer } from "./Visualizer/Visualizer";
export const AssetModalMobileLayout = /*#__PURE__*/ memo((param)=>{
    let { Banner, PDFVisualizer, PreviousAndNextArrows, VideoVisualizer, ImageVisualizer, header, panel, navigation, tabs } = param;
    return /*#__PURE__*/ _jsxs("div", {
        "data-testid": "MOBILE_ASSET_MODAL",
        className: "fixed inset-y-0 left-0 flex w-screen flex-col items-start justify-start overflow-auto bg-pigeon-850",
        children: [
            !!Banner && /*#__PURE__*/ _jsx(Banner, {}),
            header,
            /*#__PURE__*/ _jsx("div", {
                className: "flex h-auto min-h-[200px] w-full shrink-0 bg-black",
                children: /*#__PURE__*/ _jsx(Visualizer, {
                    VideoVisualizer: VideoVisualizer,
                    PDFVisualizer: PDFVisualizer,
                    ImageVisualizer: ImageVisualizer
                })
            }),
            !!PreviousAndNextArrows && /*#__PURE__*/ _jsx(PreviousAndNextArrows, {}),
            !!navigation ? navigation : /*#__PURE__*/ _jsx(AssetModalMobileTabNavigation, {
                tabs: tabs
            }),
            panel
        ]
    });
});
AssetModalMobileLayout.displayName = "AssetModalMobileLayout";
